"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
// Styled version of TabPane.
var StyledTabPane = styled_components_1.default(antd_1.Tabs.TabPane)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
// Our exported styled component version of AntTabs will need to have a reference to the styled
// component version of TabPane.
// There is a type swap here, this makes typescript happy (Antd.Tabs.TabPane => TabPane).
// This is fine, since consumers will use the styled version and 'ref' grabs the inner component.
var VarnishTabs = /** @class */ (function (_super) {
    __extends(VarnishTabs, _super);
    function VarnishTabs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VarnishTabs.TabPane = StyledTabPane;
    return VarnishTabs;
}(antd_1.Tabs));
// Styled version of Tabs.
var StyledTabs = styled_components_1.default(VarnishTabs).attrs(function () { return ({
    animated: false
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &,\n    .ant-tabs-nav-container {\n        font-size: inherit;\n    }\n\n    && .ant-tabs-tabpane {\n        transition: none;\n    }\n"], ["\n    &,\n    .ant-tabs-nav-container {\n        font-size: inherit;\n    }\n\n    && .ant-tabs-tabpane {\n        transition: none;\n    }\n"])));
// We trick Typescript here by first casting to unknown and then casting to the type we'd like to export.
// We do this so that the exported type includes the static properties, which we lose otherwise.
exports.Tabs = StyledTabs;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Tabs.js.map